import { Component } from '@angular/core';
import { ZiroSelectComponent } from '../../../../forms/fields/select/ziro-select.component';
import { ZiroFieldAbstractDirective } from '../../../../forms/ziro-field-abstract.directive';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../../../shared/pipes/pipes.module';

@Component({
  selector: 'ziro-general-settings-select',
  imports: [TranslateModule, NgClass, NgSelectComponent, FormsModule, PipesModule],
  templateUrl: './general-settings-select.component.html',
  styleUrl: './general-settings-select.component.scss',
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: GeneralSettingsSelectComponent }],
})
export class GeneralSettingsSelectComponent extends ZiroSelectComponent {}
